import React, { useEffect, useState } from 'react';
interface Purchase {
  name: string;
  state: string;
  product: string;
  variant?: string;
  image: string;
}
const purchases: Purchase[] = [{
  name: 'Rebecca H.',
  state: 'TX',
  product: 'KNOVA™ Automatic Peeler Machine',
  image: 'https://cdn.magicpatterns.com/uploads/ey92rgFEsQ2P3Ce3NGPjUt/image.png'
}, {
  name: 'Daniel P.',
  state: 'WA',
  product: 'KNOVA™ + Hand Peeler Swift',
  variant: 'Bundle',
  image: 'https://cdn.magicpatterns.com/uploads/mcnmUkk9rnYT3d8zC31P3E/image.png'
}, {
  name: 'Amanda W.',
  state: 'MA',
  product: 'KNOVA™ Automatic Peeler Machine',
  image: 'https://cdn.magicpatterns.com/uploads/ey92rgFEsQ2P3Ce3NGPjUt/image.png'
}, {
  name: 'Christopher B.',
  state: 'OR',
  product: 'KNOVA™ + Hand Peeler Swift',
  variant: 'Bundle',
  image: 'https://cdn.magicpatterns.com/uploads/mcnmUkk9rnYT3d8zC31P3E/image.png'
}, {
  name: 'Lisa M.',
  state: 'CO',
  product: 'KNOVA™ Automatic Peeler Machine',
  image: 'https://cdn.magicpatterns.com/uploads/ey92rgFEsQ2P3Ce3NGPjUt/image.png'
}, {
  name: 'Robert F.',
  state: 'IL',
  product: 'KNOVA™ + Hand Peeler Swift',
  variant: 'Bundle',
  image: 'https://cdn.magicpatterns.com/uploads/mcnmUkk9rnYT3d8zC31P3E/image.png'
}, {
  name: 'Patricia G.',
  state: 'OH',
  product: 'KNOVA™ Automatic Peeler Machine',
  image: 'https://cdn.magicpatterns.com/uploads/ey92rgFEsQ2P3Ce3NGPjUt/image.png'
}, {
  name: 'Kevin D.',
  state: 'FL',
  product: 'KNOVA™ + Hand Peeler Swift',
  variant: 'Bundle',
  image: 'https://cdn.magicpatterns.com/uploads/mcnmUkk9rnYT3d8zC31P3E/image.png'
}];
export function SalesNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show notification
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 500);
    // Hide notification after 3 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 3500);
    // Move to next notification after 10 seconds
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
    }, 10000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [currentIndex]);
  const currentPurchase = purchases[currentIndex];
  return <div className={`fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} data-id="element-355">
      <div className="bg-black/65 backdrop-blur-md rounded-lg shadow-lg p-3 md:p-4 flex items-center gap-2 md:gap-3 max-w-[280px] md:max-w-sm border border-gray-800" data-id="element-356">
        {/* Product Image */}
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-md overflow-hidden flex-shrink-0 bg-gray-800" data-id="element-357">
          <img src={currentPurchase.image} alt={currentPurchase.product} className="w-full h-full object-cover" data-id="element-358" />
        </div>

        {/* Purchase Info */}
        <div className="flex-1 min-w-0" data-id="element-359">
          <p className="text-xs md:text-sm text-white font-medium" data-id="element-360">
            <span className="font-semibold" data-id="element-361">{currentPurchase.name}</span> -{' '}
            {currentPurchase.state}
          </p>
          <p className="text-[10px] md:text-xs text-gray-300 truncate" data-id="element-362">
            just purchased
          </p>
          <p className="text-[10px] md:text-xs text-gray-400 mt-0.5" data-id="element-363">
            a few moments ago
          </p>
        </div>

        {/* Verification Badge */}
        <div className="flex-shrink-0" data-id="element-364">
          <svg className="w-4 h-4 md:w-5 md:h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20" data-id="element-365">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-366" />
          </svg>
        </div>
      </div>
    </div>;
}